import { Component, Vue } from 'vue-property-decorator';
import Event from '../utils/Event';

@Component
export default class SliderControls extends Vue {
  nextReviewSlide() {
    Event.fire('next-slide');
  }

  prevReviewSlide() {
    Event.fire('prev-slide');
  }

  stopReviewSlider() {
    // Event.fire('stop-slider');
  }

  startReviewSlider() {
    // Event.fire('start-slider');
  }
}
